<script setup lang="ts">
defineProps<{
  title: string
}>();

defineSlots<{
  default: () => unknown
}>();
</script>

<template>
  <div>
    <IadTitle
      class="pb-m"
      tag="p"
      :text="title"
      variant="x-small"
    />
    <div class="flex flex-col gap-s items-start">
      <slot />
    </div>
  </div>
</template>
